module.exports = __webpack_public_path__ + "img/instagram-stories-sticker-2.81a0d67c.png";